module.exports = __webpack_public_path__ + "5fb63f57dc56fa8703be182c80d70ddf.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/step3.png
// module id = 620
// module chunks = 0